<div>
	<table cellspacing="0">

		<tbody [ngClass]="displayForm ? 'table-body-block' : 'table-body'">
			<tr>
				<td colspan="2" class="edit-icon">
					<ng-container>
						<a
							href="#/client-dashboard?clientId={{uniqueref}}&cfw=1"
							role="button"
							aria-label="Edit Custom Fields"
							title="Edit"
							class="btn btn-icon btn-default"
						>
							<i class="ng-bento bento-icon-edit ng-star-inserted"></i>
						</a>
					</ng-container>
				</td>
			</tr>
			<ng-container *ngIf="displayForm; else noCustomFields">
				<ng-container *ngFor="let group of additionalInfoObject">
					<ng-container *ngFor="let field of group | keyvalue: onCompare">
						<tr>
							<td class="group">{{ field.key }}</td>
						</tr>
						<ng-container *ngFor="let keyvalues of field.value">
							<tr *ngFor="let keyvalue of keyvalues | keyvalue: onCompare">
								<ng-container>
									<td class="field-key">
										<div class="break-fieldName-right">{{ keyvalue.key }}</div>
									</td>
									<td class="field-value">
										<div class="break-fieldValue-left">
											{{ keyvalue.value }}
										</div>
									</td>
								</ng-container>
							</tr>
						</ng-container>
						<tr>
							<td colspan="2" class="separator"><hr /></td>
						</tr>
					</ng-container>
				</ng-container>
			</ng-container>
			<ng-template #noCustomFields>
				<tr>
					<td colspan="2" class="no-fields-message">No custom fields are configured for this client</td>
				</tr>
			</ng-template>
		</tbody>
	</table>
</div>
